import _get from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/get";
import _classCallCheck from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/inherits";
import * as React from "react";
import * as PropTypes from "prop-types";
import { SearchkitComponent, PageSizeAccessor, HighlightAccessor, CustomHighlightAccessor, SourceFilterAccessor, HitsAccessor, RenderComponentPropType, renderComponent, block } from "../../../../core";

var map = require("lodash/map");

var defaults = require("lodash/defaults");

export var HitItem =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(HitItem, _React$PureComponent);

  function HitItem() {
    _classCallCheck(this, HitItem);

    return _possibleConstructorReturn(this, _getPrototypeOf(HitItem).apply(this, arguments));
  }

  _createClass(HitItem, [{
    key: "render",
    value: function render() {
      return React.createElement("div", {
        "data-qa": "hit",
        className: this.props.bemBlocks.item().mix(this.props.bemBlocks.container("item"))
      }, this.props.result._id);
    }
  }]);

  return HitItem;
}(React.PureComponent);
export var HitsList =
/*#__PURE__*/
function (_React$PureComponent2) {
  _inherits(HitsList, _React$PureComponent2);

  function HitsList() {
    _classCallCheck(this, HitsList);

    return _possibleConstructorReturn(this, _getPrototypeOf(HitsList).apply(this, arguments));
  }

  _createClass(HitsList, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          hits = _this$props.hits,
          mod = _this$props.mod,
          className = _this$props.className,
          itemComponent = _this$props.itemComponent;
      var bemBlocks = {
        container: block(mod).el,
        item: block("".concat(mod, "-hit")).el
      };
      return React.createElement("div", {
        "data-qa": "hits",
        className: bemBlocks.container().mix(className)
      }, map(hits, function (result, index) {
        return renderComponent(itemComponent, {
          key: result._id,
          result: result,
          bemBlocks: bemBlocks,
          index: index
        });
      }));
    }
  }]);

  return HitsList;
}(React.PureComponent);
HitsList.defaultProps = {
  mod: "sk-hits",
  itemComponent: HitItem
};
HitsList.propTypes = {
  mod: PropTypes.string,
  className: PropTypes.string,
  itemComponent: RenderComponentPropType,
  hits: PropTypes.any
};
export var Hits =
/*#__PURE__*/
function (_SearchkitComponent) {
  _inherits(Hits, _SearchkitComponent);

  function Hits() {
    _classCallCheck(this, Hits);

    return _possibleConstructorReturn(this, _getPrototypeOf(Hits).apply(this, arguments));
  }

  _createClass(Hits, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      _get(_getPrototypeOf(Hits.prototype), "componentDidMount", this).call(this);

      if (this.props.hitsPerPage) {
        this.searchkit.getAccessorByType(PageSizeAccessor).defaultSize = this.props.hitsPerPage;
      }

      if (this.props.highlightFields) {
        this.searchkit.addAccessor(new HighlightAccessor(this.props.highlightFields));
      }

      if (this.props.customHighlight) {
        this.searchkit.addAccessor(new CustomHighlightAccessor(this.props.customHighlight));
      }

      if (this.props.sourceFilter) {
        this.searchkit.addAccessor(new SourceFilterAccessor(this.props.sourceFilter));
      }

      this.hitsAccessor = new HitsAccessor({
        scrollTo: this.props.scrollTo
      });
      this.searchkit.addAccessor(this.hitsAccessor);
    }
  }, {
    key: "render",
    value: function render() {
      var hits = this.getHits();
      var hasHits = hits.length > 0;

      if (!this.isInitialLoading() && hasHits) {
        var _this$props2 = this.props,
            listComponent = _this$props2.listComponent,
            mod = _this$props2.mod,
            className = _this$props2.className,
            itemComponent = _this$props2.itemComponent;
        return renderComponent(listComponent, {
          hits: hits,
          mod: mod,
          className: className,
          itemComponent: itemComponent
        });
      }

      return null;
    }
  }]);

  return Hits;
}(SearchkitComponent);
Hits.propTypes = defaults({
  hitsPerPage: PropTypes.number,
  highlightFields: PropTypes.arrayOf(PropTypes.string),
  sourceFilterType: PropTypes.oneOf([PropTypes.string, PropTypes.arrayOf(PropTypes.string), PropTypes.bool]),
  itemComponent: RenderComponentPropType,
  listComponent: RenderComponentPropType
}, SearchkitComponent.propTypes);
Hits.defaultProps = {
  listComponent: HitsList,
  scrollTo: "body"
};